module.exports = __webpack_public_path__ + "img/referra-store-pros-every-project-316x104.777d65c0.png";